module.exports = __webpack_public_path__ + "static/media/benefit_increase.06ba4944.png";